export default __webpack_public_path__ + "static/updated_data-20fd0adbc476a93e23a16367cffe0f0e.mp4";